import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Helmet from 'react-helmet';

export default class JsonLD extends Component {
  static propTypes = {
    data: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired
  }

  constructor(props) {
    super(props)
    this.state = {json: JSON.stringify(this.getJSONData(props.data))}
  }

  componentWillReceiveProps(props) {
    this.setState = {json: JSON.stringify(this.getJSONData(props.data))}
  }

  shouldComponentUpdate(nextProps, nextState) {
    return nextState.json !== this.state.json
  }

  getJSONData(data) {
    return data instanceof Array ?
      data.map(item => ({
        "@context": "http://schema.org",
        ...item // this way around allows @context to be overwritten if need be
      })) :
      {
        "@context": "http://schema.org",
        ...data // this way around allows @context to be overwritten if need be
      }
  }

  render() {
    return <Helmet>
      <script type="application/ld+json">
        {this.state.data}
      </script>
    </Helmet>;
  }
}




// WEBPACK FOOTER //
// ./modules/Common/components/JsonLD.js